import React from "react"
import classnames from "classnames"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"
import PropTypes from "prop-types"
import { compose } from "redux"
import moment from "moment"
import {
  Button,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  ListGroupItem,
  ListGroup,
  Media,
  Modal,
  Navbar,
  NavItem,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap"
import Avatar from "react-avatar"
import NotificationAlert from "react-notification-alert"
import AddToCalendar from "react-add-to-calendar"
import 'react-add-to-calendar/dist/react-add-to-calendar.css'

import logoutAction from "actions/logoutAction"
import {
  cancelOrConfirmOrder,
  updateMerchantOrderSlots,
} from "actions/organization/usersActions"

const CONFIRMED = "CONFIRMED"
const CANCELLED = "CANCELLED"

class AdminNavbar extends React.Component {
  state = {
    showModal: false,
    selectedOrder: null,
  }
  // function that on mobile devices makes the search open
  openSearch = () => {
    document.body.classList.add("g-navbar-search-showing")
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-showing")
      document.body.classList.add("g-navbar-search-show")
    }, 150)
    setTimeout(function () {
      document.body.classList.add("g-navbar-search-shown")
    }, 300)
  }
  // function that on mobile devices makes the search close
  closeSearch = () => {
    document.body.classList.remove("g-navbar-search-shown")
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-show")
      document.body.classList.add("g-navbar-search-hiding")
    }, 150)
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hiding")
      document.body.classList.add("g-navbar-search-hidden")
    }, 300)
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hidden")
    }, 500)
  }

  toggleModal = () => {
    this.setState((state) => ({ showModal: !state.showModal }))
  }

  handleNotificationItemClick = (notification) => {
    const { orderId } = notification
    const { orders } = this.props
    let selectedOrder
    if (orders && orders.length > 0) {
      selectedOrder = orders.find((order) => order.orderId === orderId)
      if (selectedOrder) {
        this.setState({ selectedOrder })
      }
    }
    this.toggleModal()
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  _isOrderConfirmedOrCancelled(type = "") {
    // TODO: Refactor Similar Code Among _isOrderConfirmedOrCancelled && _getAddToCalendarEvent
    const {
      selectedOrder: { orderId: selectedOrderId },
    } = this.state
    const { orders } = this.props
    if (selectedOrderId && orders && orders.length > 0) {
      const updatedSelectedOrder = orders.find(
        (v) => v.orderId === selectedOrderId
      )
      if (updatedSelectedOrder && type === CONFIRMED) {
        return updatedSelectedOrder.merchantConfirmed === true
      }
      if (updatedSelectedOrder && type === CANCELLED) {
        return updatedSelectedOrder.merchantCancelled === true
      }
    }
    return false
  }

  _getHoursFromTimeString(time) {
    let num = 0
    if (time) {
      const timeArr = time.split(":")
      let hour = parseInt(timeArr[0])
      let min = parseInt(timeArr[1])
      num = hour
      if (min) {
        num += 0.5
      }
      return num
    }
    return num
  }

  _getAddToCalendarEvent() {
    // TODO: Refactor Commong Code From MerchantDashboard - _getAddToCalendarEvent
    let reactAddEvent = {
      title: "FAVER Event",
      location: "",
      description: "",
    }
    const { selectedOrder } = this.state
    if (selectedOrder) {
      const {
        selectedOrder: { orderId: selectedOrderId },
      } = this.state
      const { orders } = this.props
      if (selectedOrderId && orders && orders.length > 0) {
        const updatedSelectedOrder = orders.find(
          (v) => v.orderId === selectedOrderId
        )
        if (updatedSelectedOrder) {
          const {
            city,
            orderId,
            firstName,
            lastName,
            phone,
            addressLine1,
            addressLine2,
            zipCode,
            totalCost,
            orderDate,
            orderTime,
            orderDuration,
            vehicleType,
            package: pkg,
            addon,
          } = updatedSelectedOrder
          reactAddEvent = {
            ...reactAddEvent,
            location: city,
            description: `Name: ${firstName} ${lastName}\nPhone: ${phone}\nAddress: ${addressLine1}, ${
              addressLine2 ? addressLine2 + ", " : ""
            }${city}, ${zipCode}\nTotal Amount: $${totalCost}\nOrder Date: ${orderDate
              .toDate()
              .toDateString()}\nOrder Time: ${orderTime}\nOrder Duration: ${orderDuration} Min\nVehicle Type: ${
              vehicleType.title
            }\nPackage: ${pkg.title}\nAddon: ${
              addon.map((v) => v.title).join(", ") || "NA"
            }\nOrderId: ${orderId}`,
            startTime: new Date(
              orderDate.toDate().getTime() +
                this._getHoursFromTimeString(orderTime) * 60 * 60 * 1000
            ),
            endTime: new Date(
              orderDate.toDate().getTime() +
                this._getHoursFromTimeString(orderTime) * 60 * 60 * 1000 +
                +orderDuration * 60 * 1000
            ),
          }
        }
      }
    }
    return reactAddEvent
  }

  render() {
    const { auth, notifications, profile } = this.props
    let sortedNotifications = []
    const { email } = auth
    if (notifications && notifications.length > 0) {
      sortedNotifications = [...notifications].sort(
        (a, b) => b.time.toDate().getTime() - a.time.toDate().getTime()
      )
    }
    const { selectedOrder } = this.state
    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Navbar
          className={classnames(
            "navbar-top navbar-expand border-bottom bg-chift"
          )}
        >
          <Container fluid>
            <Collapse navbar isOpen={true}>
              <Nav className="align-items-center ml-md-auto" navbar>
                <NavItem className="d-xl-none">
                  <div
                    className={classnames(
                      "pr-3 sidenav-toggler",
                      { active: this.props.sidenavOpen },
                      { "sidenav-toggler-dark": this.props.theme === "dark" }
                    )}
                    onClick={this.props.toggleSidenav}
                  >
                    <div className="sidenav-toggler-inner">
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                    </div>
                  </div>
                </NavItem>
                <UncontrolledDropdown nav>
                  <DropdownToggle className="nav-link" tag="a">
                    <i
                      className="ni ni-bell-55 text-white"
                      style={{ cursor: "pointer" }}
                    />
                  </DropdownToggle>
                  <DropdownMenu
                    className="dropdown-menu-xl py-0 overflow-hidden"
                    right
                  >
                    {/* <div className="px-3 py-3">
                      <h6 className="text-sm text-muted m-0">
                        You have <strong className="text-info">13</strong>{" "}
                        notifications.
                      </h6>
                    </div> */}
                    <ListGroup
                      flush
                      style={{ maxHeight: 350, overflowY: "scroll" }}
                    >
                      {sortedNotifications && sortedNotifications.length > 0 ? (
                        sortedNotifications.map((ntf, idx) => {
                          return (
                            <ListGroupItem
                              className="list-group-item-action"
                              // href="#"
                              onClick={(e) => {
                                e.preventDefault()
                                this.handleNotificationItemClick(ntf)
                              }}
                              tag="a"
                              key={ntf.title + idx}
                              style={{ cursor: "pointer" }}
                            >
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <Avatar
                                    size="40"
                                    round
                                    name={ntf.customerName || ""} // Cannot Read Property "parentNode" Of null
                                  />
                                </Col>
                                <div className="col ml--2">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <h4 className="mb-0 text-sm">
                                        {ntf.title[email]}
                                      </h4>
                                    </div>
                                    <div className="text-right text-muted">
                                      <small>
                                        {moment(ntf.time.toDate()).fromNow()}
                                      </small>
                                    </div>
                                  </div>
                                  <p className="text-sm mb-0">{ntf.orderId}</p>
                                </div>
                              </Row>
                            </ListGroupItem>
                          )
                        })
                      ) : (
                        <ListGroupItem>No Notifications</ListGroupItem>
                      )}
                    </ListGroup>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
              <Nav className="align-items-center ml-auto ml-md-0" navbar>
                <UncontrolledDropdown nav>
                  <DropdownToggle className="nav-link pr-0" color="" tag="a">
                    <Media className="align-items-center">
                      <span className="avatar avatar-sm rounded-circle">
                        {auth.photoURL ? (
                          <img alt="..." src={auth.photoURL} />
                        ) : (
                          <Avatar
                            size="40"
                            round
                            name={
                              profile && profile.token
                                ? profile.token.claims.name
                                : ""
                            }
                          />
                        )}
                        {/* <img
                          alt="..."
                          src={
                            !auth.photoURL
                              ? require("assets/img/theme/blank-profile.png")
                              : auth.photoURL
                          }
                        /> */}
                      </span>
                      <Media className="ml-2 d-none d-lg-block">
                        <span className="mb-0 text-sm font-weight-bold text-white">
                          {auth && auth.displayName}
                        </span>
                      </Media>
                    </Media>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">Welcome!</h6>
                    </DropdownItem>
                    {/*<Link to="/m/profile">
                    <DropdownItem>
                      <i className="ni ni-single-02" />
                      <span>My profile</span>
                    </DropdownItem>
                    </Link>
                    <DropdownItem
                      href="#fa"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="ni ni-support-16" />
                      <span>Support</span>
                    </DropdownItem>
                    <DropdownItem divider />*/}
                    <DropdownItem onClick={this.props.logoutAction}>
                      <i className="ni ni-user-run" />
                      <span>Logout</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
              <Modal
                isOpen={this.state.showModal}
                toggle={() => this.toggleModal()}
                className="modal-dialog-centered modal-secondary"
              >
                <div className="modal-header">
                  <h6 className="modal-title" id="modal-title-default">
                    Order Summary
                  </h6>
                  <Col className="text-right" xs="6">
                      <AddToCalendar
                          buttonLabel="Add to Calendar"
                          event={this._getAddToCalendarEvent()}
                          listItems={[
                            { google: "Google" },
                            { apple: "Apple Calendar" },
                            { outlook: "Outlook" },
                            { outlookcom: "Outlook.com" },
                          ]}
                        />
                  </Col>
                </div>
                <div className="modal-body">
                  {selectedOrder ? (
                    <React.Fragment>
                      <b className="form-control-label">Name:</b>{" "}
                      {`${selectedOrder.firstName} ${selectedOrder.lastName}`}
                      <br />
                      <b className="form-control-label">Phone:</b>{" "}
                      {selectedOrder.phone}
                      <br />
                      <b className="form-control-label">Address:</b>{" "}
                      {selectedOrder.addressLine1 +
                        ", " +
                        (selectedOrder.addressLine2
                          ? selectedOrder.addressLine2 + ", "
                          : "") +
                        selectedOrder.city +
                        ", " +
                        selectedOrder.zipCode}
                      <br />
                      <b className="form-control-label">Total Amount:</b>{" "}
                      {`$${selectedOrder.totalCost}`}
                      <br />
                      <b className="form-control-label">Order Date:</b>{" "}
                      {selectedOrder.orderDate?.toDate().toDateString()}
                      <br />
                      <b className="form-control-label">Order Time:</b>{" "}
                      {selectedOrder.orderTime}
                      <br />
                      <b className="form-control-label">Order Duration:</b>{" "}
                      {selectedOrder.orderDuration
                        ? selectedOrder.orderDuration + " Min"
                        : "-"}
                      <br />
                      <b className="form-control-label">Vehicle Type:</b>{" "}
                      {selectedOrder.vehicleType?.title}
                      <br />
                      <b className="form-control-label">Package:</b>{" "}
                      {selectedOrder.package?.title}
                      <br />
                      <b className="form-control-label">Addons:</b>{" "}
                      {selectedOrder.addon?.map((v) => v.title).join(", ") ||
                        "NA"}
                      <br />
                      <b className="form-control-label">Order Id:</b>{" "}
                      {selectedOrder.orderId || ""}
                      <br />
                      <br />
                    </React.Fragment>
                  ) : (
                    <p className="mb-0">Order Info Not Available.</p>
                  )}
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-evenly w-100">
                    {selectedOrder ? (
                      <React.Fragment>
                        <Button
                          disabled={this._isOrderConfirmedOrCancelled(
                            CONFIRMED
                          )}
                          color="primary"
                          onClick={() => {
                            this.props
                              .cancelOrConfirmOrder({
                                status: "confirm",
                                orderId: selectedOrder.orderId,
                              })
                              .then((isOrderCancelledOrConfirmed) => {
                                if (isOrderCancelledOrConfirmed) {
                                  this.notify(
                                    "success",
                                    "Order Confirmed!",
                                    "Confirmed"
                                  )
                                }
                              })
                          }}
                        >
                          {this._isOrderConfirmedOrCancelled(CONFIRMED)
                            ? "Confirmed"
                            : "Confirm"}
                        </Button>
                        <Button
                          disabled={this._isOrderConfirmedOrCancelled(
                            CANCELLED
                          )}
                          color="primary"
                          onClick={() => {
                            this.props
                              .cancelOrConfirmOrder({
                                status: "cancel",
                                orderId: selectedOrder.orderId,
                              })
                              .then((isOrderCancelledOrConfirmed) => {
                                if (isOrderCancelledOrConfirmed) {
                                  // const updateData = this._getUpdateDataForMerchantOrderSlots(
                                  //   selectedOrder
                                  // )
                                  // this.props.updateMerchantOrderSlots({
                                  //   updateData,
                                  //   docId: selectedOrder.merchantId,
                                  // })
                                  this.notify(
                                    "danger",
                                    "Order Cancelled!",
                                    "Cancelled"
                                  )
                                }
                              })
                          }}
                        >
                          {this._isOrderConfirmedOrCancelled(CANCELLED)
                            ? "Cancelled"
                            : "Cancel"}
                        </Button>
                      </React.Fragment>
                    ) : null}
                    <Button
                      className="ml-auto"
                      color="link"
                      onClick={() => {
                        this.toggleModal()
                        this.setState({ selectedOrder: null })
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Modal>
            </Collapse>
          </Container>
        </Navbar>
      </>
    )
  }
}

AdminNavbar.defaultProps = {
  sidenavOpen: false,
  theme: "dark",
  toggleSidenav: () => {},
}

AdminNavbar.propTypes = {
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(["dark", "light"]),
  toggleSidenav: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    notifications: state.firestore.ordered.notifications,
    oid: state.firebase.profile.organization_id,
    orders: state.firestore.ordered.adminOrders,
    org: state.firestore.data.org,
    profile: state.firebase.profile,
  }
}

const mapDispatchToProps = (dispatch) => ({
  logoutAction: () => dispatch(logoutAction()),
  cancelOrConfirmOrder: (data) => dispatch(cancelOrConfirmOrder(data)),
  updateMerchantOrderSlots: (data) => dispatch(updateMerchantOrderSlots(data)),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    return [
      {
        collection: "notifications",
        where: ["email", "array-contains", props.auth.email],
        storeAs: "notifications",
      },
      {
        collection: "orders",
        where: ["merchantEmail", "==", props.auth.email],
        storeAs: "adminOrders",
      },
    ]
  })
)(AdminNavbar)
